import React from "react";
import VBarChart from "../../../graphs/VBarChart";


interface Props {
  value: { country: string; value: number }[];
}

const PercentageChangeCPI: React.FC<Props> = ({ value }) => {
  return (
    <div>
      {value.length && (
        <VBarChart data={value} id="percentageChangeCPI" is_xAxis={false} />
      )}
    </div>
  );
};

export default PercentageChangeCPI;
